export default __webpack_public_path__ + "static/media/bp-icon.4da184de.svg";